import { put, take, takeLatest, call, select } from 'redux-saga/effects';

import contactService from 'services/contactService';

import { contactDrawer, open, save, types } from './actions';
import { MODES } from './constants';
import { getContactId, getMode } from './reducer';

export default function* root() {
  yield takeLatest(types.OPEN_REQUEST, watchInitiateDrawer);
  yield takeLatest(types.SAVE_REQUEST, watchSaveContact);
}

function* watchInitiateDrawer(action) {
  try {
    const { callBack } = action.payload;
    const mode = yield select(getMode);
    if (mode === MODES.EDIT) {
      // fetch current contact
      const contactId = yield select(getContactId);
      const contact = yield call(contactService.contacts.get, contactId);

      yield put(contactDrawer.setContact({ contact }));
    }

    yield put(open.success());

    if (callBack) {
      const action = yield take(types.SAVE_SUCCESS);
      yield call(callBack, {
        contactId: action.payload.contactId,
        contact: action.payload.contact,
      });
    }
  } catch (error) {
    yield put(open.error(error));
  }
}

function* watchSaveContact(action) {
  try {
    const {
      accountId,
      address1,
      address2,
      city,
      country,
      email,
      firstName,
      lastName,
      notes,
      phone,
      phoneExt,
      postalCode,
      salespersonId,
      state,
    } = action.payload;

    let address = undefined;
    let addressId = undefined;
    if (address1) {
      address = {
        address1,
        address2,
        city,
        country,
        postalCode,
        state,
      };
    } else {
      addressId = null;
    }
    const requestData = {
      accountId,
      address,
      addressId,
      email,
      firstName,
      lastName,
      notes,
      phone,
      phoneExt,
      salespersonId,
    };

    const mode = yield select(getMode);
    const contactId = yield select(getContactId);
    let contact;

    if (mode == MODES.CREATE) {
      contact = yield call(contactService.contacts.create, requestData);
    } else {
      contact = yield call(
        contactService.contacts.update,
        contactId,
        requestData,
      );
    }

    yield put(save.success({ contactId: contact.id, contact }));
  } catch (error) {
    yield put(save.error(error));
  }
}
